import React from 'react';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { StyledCloseButton } from './CloseButton.style';

interface Props {
  onClose: () => void;
}

const CloseButton: React.FC<Props> = ({ onClose }) => (
  <StyledCloseButton aria-label='close' onClick={onClose}>
    <CloseRoundedIcon />
  </StyledCloseButton>
);

export default CloseButton;
